export default {
  computed: {
    advanced: {
      get () {
        return this.$store.getters.advanced
      }
    },

    filters_counts:{
      get () {
        return this.$store.getters.filters_counts;
      }
    },
  },

  methods     :
    {
      toggleFilters: function(){
        //this.$store.dispatch('setAdvanced', !this.advanced);
        let this_=this;
        let T=null;
        let is_seteed=false;

        if ( this_.advanced ){
          $(".works-filter__block-advanced").slideDown( function(){
            clearTimeout(T);
            T=setTimeout( function(){
              //чтобы один раз сработало
              if ( is_seteed ) return;
              is_seteed=true;

              //console.log(this_.advanced);
              this_.$store.dispatch('setAdvanced', false);
            }, 100 );
          } );
        }
        else {
          $(".works-filter__block-advanced").slideUp( function(){
            clearTimeout(T);
            T=setTimeout( function(){
              //чтобы один раз сработало
              if ( is_seteed ) return;
              is_seteed=true;

              //console.log(this_.advanced);
              this_.$store.dispatch('setAdvanced', true);
            }, 100 );
          } );
        }
      },
      mobileShow: function () {
        if ( $('.works-filter__blocks').is(':visible') ){
          $('.works-filter__blocks').css('display', '');
        }else{
          $('.works-filter__blocks').show()
        }
      },

      /*created() {

      },*/

      childupdated: function () {
        if ( $('.works-filter__block-advanced').length==0 ) $('.works-filter__block-advanced-filter').hide();
        else $('.works-filter__block-advanced-filter').show();

        /*let params={
          'onUpdate': function(){
              if ( $('.list-container').data('updated')=='1' ){
                $('.list-container').data('updated', '0');
                $('.list-container').scrollbar('destroy').data('scrollbarinited', '0');
                window.global.init_scrollbar($('.list-container'), params);
                $('.list-container').data('updated', '0');
              }
            }
        };*/
        window.global.init_scrollbar_lq('.list-container');//, params);
      }
    },
}



//////////////////
// WEBPACK FOOTER
// ./src/components/list/WorksFilterMix.js
// module id = null
// module chunks = 